import { Accordion } from "./UI";
import { LangContext } from "../App";
import { useContext, useState } from "react";
import { ChevronDownIcon } from "lucide-react";
import { style } from "framer-motion/m";
import styled from "styled-components";
import styles from "./Footer.module.css";
import useTxt from "../useTxt";

const basePath = window.location.pathname.includes("/minecraft.dev")
? "/minecraft.dev"
: "";
const FLinks = {
  de: [
    {
      title: "Über uns",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/de-ch/our-history.html",
          title: "Unsere Geschichte",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/franchising.html",
          title: "Franchising",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/engagement/engagement-produkte.html",
          title: "Qualität",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/rechtliche-informationen/terms-and-conditions.html",
          title: "AGB's",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/rechtliche-informationen/dataprotection.html",
          title: "Datenschutz",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/rechtliche-informationen/impressum.html",
          title: "Impressum",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/vorsicht-vor-phishing-fallen.html",
          title: "Vorsicht vor Phishing-Fallen",
        },
      ],
    },
    {
      title: "Engagement",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/de-ch/engagement.html",
          title: "Engagement",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/our-people.html",
          title: "Die Menschen",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/together-for-gold.html",
          title: "Sportförderprogramm",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/ronald-mcdonald.html",
          title: "Ronald McDonald Kinderstiftung",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/education-opportunites.html",
          title: "Entwicklungsmöglichkeiten",
        },
      ],
    },
    {
      title: "Services",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/de-ch/restaurant-services.html",
          title: "Services in unseren Restaurants",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/mcdelivery.html",
          title: "McDelivery®",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/mcdrive.html",
          title: "McDrive®",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/orderandpay.html",
          title: "Order&Pay",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/app.html",
          title: "App",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/mymcdonalds.html",
          title: "Bonusprogramm",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/family.html",
          title: "Familie",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/family/anniversary.html",
          title: "Geburtstag feiern",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/giftcard.html",
          title: "Geschenkkarten",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/wifi.html",
          title: "WLAN",
        },
      ],
    },
    {
      title: "Newsroom",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/de-ch/newsroom.html",
          title: "Übersicht",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/newsroom/media-asset.html",
          title: "Bilder und Videos",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/newsroom/news.html",
          title: "Medienmitteilungen",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/newsroom/zahlen-und-fakten.html",
          title: "Zahlen und Fakten",
        },
      ],
    },
    {
      title: "Kontakt",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/de-ch/FAQ.html",
          title: "FAQ",
        },
        {
          link: "https://jobs.mcdonalds.ch/de",
          title: "Jobs und Lehre",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/kontakt-formular.html",
          title: "Kontakt Formular | Fragen über McDonald's® Schweiz",
        },
        {
          link: "https://www.mcdonalds.com/ch/de-ch/medien-kontakt.html",
          title: "Medien Kontakt",
        },
      ],
    },
  ],

  fr: [
    {
      title: "A propos",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/our-history.html",
          title: "Notre histoire",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/franchising.html",
          title: "Franchise",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/engagement/engagement-produkte.html",
          title: "Qualité",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/rechtliche-informationen/terms-and-conditions.html",
          title: "Conditions générales",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/rechtliche-informationen/dataprotection.html",
          title: "Protection des données",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/rechtliche-informationen/impressum.html",
          title: "Impressum",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/attention-au-phishing.html",
          title: "Attention au phishing",
        },
      ],
    },
    {
      title: "Engagement",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/engagement.html",
          title: "Engagement",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/our-people.html",
          title: "Les personnes",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/together-for-gold.html",
          title: "Soutien sportif",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/ronald-mcdonald.html",
          title: "La Fondation Ronald McDonald Suisse",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/education-opportunites.html",
          title: "Opportunités de développement",
        },
      ],
    },
    {
      title: "Services",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/restaurant-services.html",
          title: "Services dans nos restaurants",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/mcdelivery.html",
          title: "McDelivery®",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/mcdrive.html",
          title: "McDrive®",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/orderandpay.html",
          title: "Order&Pay",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/app.html",
          title: "App",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/mymcdonalds.html",
          title: "Fidélité",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/family.html",
          title: "Famille",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/family/anniversary.html",
          title: "Fêter son anniversaire",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/giftcard.html",
          title: "Cartes cadeau",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/wifi.html",
          title: "Wifi",
        },
      ],
    },
    {
      title: "Newsroom",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/newsroom.html",
          title: "Vue d'ensemble",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/newsroom/media-asset.html",
          title: "Images et vidéos",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/newsroom/news.html",
          title: "Communiqués de presse",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/newsroom/chiffres-et-faits.html",
          title: "Chiffres et faits",
        },
      ],
    },
    {
      title: "Nous contacter",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/FAQ.html",
          title: "FAQ",
        },
        {
          link: "https://jobs.mcdonalds.ch/",
          title: "Jobs et apprentissage",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/kontakt-formular.html",
          title: "Formulaire de contact | McDonald's® Suisse",
        },
        {
          link: "https://www.mcdonalds.com/ch/fr-ch/medien-kontakt.html",
          title: "Contact médias",
        },
      ],
    },
  ],

  it: [
    {
      title: "A proposito",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/it-ch/our-history.html",
          title: "La nostra storia",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/franchising.html",
          title: "Franchising",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/engagement/engagement-produkte.html",
          title: "Qualità",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/rechtliche-informationen/terms-and-conditions.html",
          title: "Termini e condizioni",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/rechtliche-informationen/dataprotection.html",
          title: "Protezione dei dati",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/rechtliche-informationen/impressum.html",
          title: "Impressum",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/attenzione-alle-trappole-di-phishing.html",
          title: "Attenzione alle Trappole di Phishing",
        },
      ],
    },
    {
      title: "Impegno",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/it-ch/engagement.html",
          title: "Impegno",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/our-people.html",
          title: "Le persone",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/together-for-gold.html",
          title: "Promozione sportiva",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/ronald-mcdonald.html",
          title: "Fondazione Ronald McDonald",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/education-opportunites.html",
          title: "Opportunità di sviluppo",
        },
      ],
    },
    {
      title: "Servizi",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/it-ch/restaurant-services.html",
          title: "Servizi nei nostri ristoranti",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/mcdelivery.html",
          title: "McDelivery®",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/mcdrive.html",
          title: "McDrive®",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/orderandpay.html",
          title: "Order&Pay",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/app.html",
          title: "App",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/mymcdonalds.html",
          title: "Fedeltà",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/family.html",
          title: "Famiglia",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/family/anniversary.html",
          title: "Feste di compleanno",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/giftcard.html",
          title: "Carte regalo",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/wifi.html",
          title: "Wifi",
        },
      ],
    },
    {
      title: "Newsroom",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/it-ch/newsroom.html",
          title: "Riepilogo",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/newsroom/immagini-e-video.html",
          title: "Immagini e video",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/newsroom/news.html",
          title: "Comunicati stampa",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/newsroom/fatti-e-cifre.html",
          title: "Fatti e cifre",
        },
      ],
    },
    {
      title: "Contatto",
      links: [
        {
          link: "https://www.mcdonalds.com/ch/it-ch/FAQ.html",
          title: "FAQ",
        },
        {
          link: "https://jobs.mcdonalds.ch/it/",
          title: "Impieghi e apprendistato",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/kontakt-formular.html",
          title: "Modulo di contatto | McDonald's® Svizzera",
        },
        {
          link: "https://www.mcdonalds.com/ch/it-ch/medien-kontakt.html",
          title: "Contatto per i media",
        },
      ],
    },
  ],
};

const Cnt = styled.div`
  color: white;  
  background: url(${basePath}/img/bg_02.png) repeat;
  position: relative;
  margin-top: 200px;
`;
export function Footer(props) {
  let tr = useTxt();
  const [openItems, setOpenItems] = useState([]);
  const [lang, setLang] = useContext(LangContext);
  console.log(Accordion);

  const handleToggle = (itemTitle) => {
    setOpenItems((prevOpenItems) => {
      const newOpenItems = prevOpenItems.includes(itemTitle)
        ? prevOpenItems.filter((title) => title !== itemTitle)
        : [...prevOpenItems, itemTitle];
      console.log(itemTitle, "itemTitle ");
      document.querySelectorAll("button").forEach((button) => {
        if (button.textContent.trim() === itemTitle) {
          button.setAttribute(
            "data-state",
            newOpenItems.includes(itemTitle) ? "open" : "closed"
          );
          button.setAttribute(
            "aria-expanded",
            newOpenItems.includes(itemTitle).toString()
          );
        }
      });

      return newOpenItems;
    });
  };

  // return null;
  return (
    <Cnt>
      <div className={styles.c3al}>
        <img className="footer_img" src={`${basePath}/img/3al.png`} />
      </div>
      <Accordion.Root defaultValue={[]} className={styles.accordion}>
        {FLinks[lang].map((item) => (
          <Accordion.Item className="footer_title" key={item.title} value={item.title}>
            <Accordion.Trigger  onClick={() => handleToggle(item.title)}>
              {item.title}
            </Accordion.Trigger>
            {openItems.includes(item.title) && (
              <Accordion.Content>
                {item.links.map((link) => (
                  <a key={link.link} href={link.link}>
                    {link.title}
                  </a>
                ))}
              </Accordion.Content>
            )}
          </Accordion.Item>
        ))}
      </Accordion.Root>

      <div className={styles.slinks}>
        <a
          className={styles.slink}
          href="https://www.facebook.com/McDonaldsSwitzerland/"
        >
          <img src={`${basePath}/img/facebook.png`} />
        </a>
        <a
          className={styles.slink}
          href="https://twitter.com/mcdschweiz?lang=en"
        >
          <img src={`${basePath}/img/Logo_X_32x32px_V2.png`} />
        </a>
        <a
          className={styles.slink}
          href="https://www.youtube.com/user/McDonaldsSchweiz/about?disable_polymer=1"
        >
          <img src={`${basePath}/img/youtube.png`} />
        </a>
        <a
          className={styles.slink}
          href="https://www.instagram.com/mcdonalds_switzerland/?hl=en"
        >
          <img src={`${basePath}/img/instagram.png`} />
        </a>
      </div>

      <div className={styles.slinks2}>
        <a href="https://play.google.com/store/apps/details?id=com.mcdonalds.mobileapp">
          <img
            src={`${basePath}/img/google_play.png`}
          />
        </a>
        <a href="https://itunes.apple.com/ch/app/mcdonalds/id1217507712">
          <img
            src={`${basePath}/img/app_store.png`}
          />
        </a>
      </div>
      <div className={styles.slinks3}>
        <img
          src={`${basePath}/img/c61a50639852a0be87dc8dddb7dc29cdcacb1818.png`}
        />
        {tr(`© 2025 McDonald’s®. Alle Rechte vorbehalten.`)}
      </div>
    </Cnt>
  );
}
